/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeShowcasePhoto } from './ChallengeShowcasePhoto';
import {
    ChallengeShowcasePhotoFromJSON,
    ChallengeShowcasePhotoFromJSONTyped,
    ChallengeShowcasePhotoToJSON,
    ChallengeShowcasePhotoToJSONTyped,
} from './ChallengeShowcasePhoto';

/**
 * 
 * @export
 * @interface ChallengeShowcasePhotosResponse
 */
export interface ChallengeShowcasePhotosResponse {
    /**
     * 
     * @type {Array<ChallengeShowcasePhoto>}
     * @memberof ChallengeShowcasePhotosResponse
     */
    photos: Array<ChallengeShowcasePhoto>;
}

/**
 * Check if a given object implements the ChallengeShowcasePhotosResponse interface.
 */
export function instanceOfChallengeShowcasePhotosResponse(value: object): value is ChallengeShowcasePhotosResponse {
    if (!('photos' in value) || value['photos'] === undefined) return false;
    return true;
}

export function ChallengeShowcasePhotosResponseFromJSON(json: any): ChallengeShowcasePhotosResponse {
    return ChallengeShowcasePhotosResponseFromJSONTyped(json, false);
}

export function ChallengeShowcasePhotosResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeShowcasePhotosResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'photos': ((json['photos'] as Array<any>).map(ChallengeShowcasePhotoFromJSON)),
    };
}

export function ChallengeShowcasePhotosResponseToJSON(json: any): ChallengeShowcasePhotosResponse {
    return ChallengeShowcasePhotosResponseToJSONTyped(json, false);
}

export function ChallengeShowcasePhotosResponseToJSONTyped(value?: ChallengeShowcasePhotosResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'photos': ((value['photos'] as Array<any>).map(ChallengeShowcasePhotoToJSON)),
    };
}

